import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export default (Component) => (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const history = {
    location,
    push: (path, state) => navigate(path, { state }),
    replace: (path, state) => navigate(path, { replace: true, state }),
  };

  const match = { params: useParams() };

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} history={history} location={location} match={match} />;
};
